module.exports = __webpack_public_path__ + "img/hong-kong.6738eacd.png";